var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_922_333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -972,
    y: -1016,
    width: 1440,
    height: 2800,
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_922_333)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -672.211,
    y: -763.76,
    width: 1110,
    height: 2502.96,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#032339"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9999 27.7999L12.9263 23.5999C11.9687 22.8341 12.3887 21.2941 13.6039 21.1205L20.7999 20.7999L23.8729 13.0957C24.0871 12.6687 24.5225 12.3999 24.9999 12.3999C25.4773 12.3999 25.9127 12.6701 26.1269 13.0957L29.1999 20.7999L36.3959 21.1205C37.6111 21.2941 38.0311 22.8341 37.0735 23.5999L31.9999 27.7999L33.3845 35.9997C33.5441 37.1183 32.3821 37.9555 31.3727 37.4501L24.9999 33.3999L18.6271 37.4487C17.6163 37.9541 16.4557 37.1169 16.6153 35.9983L17.9999 27.7999Z",
    fill: "#FFB608"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -971.5,
    y: -1015.5,
    width: 1439,
    height: 2799,
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_922_333",
    x: -720.211,
    y: -809.76,
    width: 1206,
    height: 2598.96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_922_333"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_922_333",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_922_333"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -972,
    y: -1016,
    width: 1440,
    height: 2800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/RatingStar.639ff4ad667608d143fb01a1d1bbaa30.svg";
export { ForwardRef as ReactComponent };